import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function getPublicRfq(token) {
  const { data } = await axios.get(
    `${API_URL}/api/public/rfq/${encodeURIComponent(token)}`,
  );
  return data;
}

export async function getPublicRfqSubgrupos(token) {
  const { data } = await axios.get(
    `${API_URL}/api/public/rfq/${encodeURIComponent(token)}/subgrupos`,
  );
  return data;
}

export async function submitPublicRfqQuote(token, payload) {
  const { data } = await axios.post(
    `${API_URL}/api/public/rfq/${encodeURIComponent(token)}/quote`,
    payload,
  );
  return data;
}
